/**
 * Custom cache expiry times for specific queries (in milliseconds)
 * If not specified, defaults to MAX_CACHE_AGE (12 hours)
 */
export const QUERY_CACHE_EXPIRY: Record<string, number> = {
  // Add custom expiry times here:
  // "router.procedure": 5 * 60 * 1000, // 5 minutes
  // "users.getUserWithTeam": 10 * 60 * 1000, // 10 minutes
}

/**
 * Query keys that should NEVER be persisted (BLACKLIST)
 *
 * Only add queries here that must ALWAYS be fresh:
 * - Authentication/session data (security risk)
 * - Real-time status/progress data (stale data useless)
 * - Payment/billing information (security + must be current)
 * - API keys or secrets (security risk)
 *
 * Everything else will be cached automatically!
 */
export const SKIP_PERSIST_KEYS = [
  // Authentication & Session (security)
  "auth.getSession",
  "auth",
  "session",
  "getSession",
  "verifyToken",

  // API Keys & Secrets (security)
  "apiKey",
  "getCurrentApiKey",

  // Add more blacklist patterns here as needed
] as const

/**
 * Cache version - automatically invalidates on each deploy via git hash
 * In development: Uses manual version (v2-dev)
 * In production: Uses git commit hash (v2-abc123)
 *
 * The git commit hash is injected at build time by vite-plugin-git-revision
 */
export const CACHE_VERSION =
  import.meta.env.MODE === "production"
    ? `v3-${(import.meta.env.VITE_COMMITHASH as string)?.substring(0, 8) || "unknown"}`
    : "v3-dev"

/**
 * Maximum age for persisted queries. Long enough that the next morning opens on the last numbers (each query
 * shows them, then refetches on mount since staleTime is 1m); queries that must never show stale go in
 * SKIP_PERSIST_KEYS. v3 = superjson format, so Dates survive a reload.
 */
export const MAX_CACHE_AGE = 12 * 60 * 60 * 1000 // 12 hours
